<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col cols="12" md="12">
        <component-header
          title="Edit Tax Code"
          :hasSearch="false"
          :hasReload="false"
          :hasCreate="false"
          :hasback="true"
          @back-press="$router.push({ name: 'Taxcode' })"
        />
      </b-col>
    </b-row>
    <b-row class="mt-2" v-if="Object.keys(details).length">
      <b-col cols="12" md="12">
        <b-card>
          <ValidationObserver ref="observer" v-slot="{ invalid }">
            <b-row>
              <b-col cols="12" md="12">
                <div slot="header"></div>
                <b-row class="font-md">
                  <b-col cols="12" sm="12" md="6">
                    <div class="form-group">
                      <span>Tax Code</span>
                      <ValidationProvider
                        rules="required"
                        v-slot="{ errors }"
                        name="Tax code"
                      >
                        <input class="form-control" v-model="details.taxCode" />
                        <span class="validate-error">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </div>
                  </b-col>
                  <b-col md="6">
                    <div class="form-group">
                      <span>Country</span>
                      <ValidationProvider
                        rules="required"
                        v-slot="{ errors }"
                        name="Country"
                      >
                        <input class="form-control" v-model="details.country" />
                        <span class="validate-error">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </div>
                  </b-col>
                </b-row>
                <b-row class="font-md">
                  <b-col md="6">
                    <div class="form-group">
                      <span>Start Date</span>
                      <ValidationProvider
                        rules="required|futureDisable"
                        v-slot="{ errors }"
                        name="start-date"
                      >
                        <b-input
                          id="start-date"
                          type="date"
                          v-model="details.startDate"
                        ></b-input>
                        <span class="validate-error">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </div>
                  </b-col>
                  <b-col md="6">
                    <div class="form-group">
                      <span>End Date</span>
                      <ValidationProvider
                        rules="required|futureDisable|afterDate:start-date"
                        v-slot="{ errors }"
                        name="end-date"
                      >
                        <b-input
                          id="end-date"
                          type="date"
                          v-model="details.endDate"
                        ></b-input>
                        <span class="validate-error">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </div>
                  </b-col>
                </b-row>
                <div
                  v-for="(data, idx) in details.restData.details"
                  :key="idx"
                  class="mt-4"
                >
                  <b-col
                    v-for="(taxLine, lIdx) in data.taxLines"
                    :key="lIdx"
                  >
                    <b-row>
                      <b-col cols="12" md="9" class="tax-fields-col">
                        <b-row>
                          <b-col cols="12" sm="6" md="4" class="tax-line-name-col">
                            <div class="form-group">
                              <label for="start-date">Tax Line Name</label>
                              <ValidationProvider
                                rules="required"
                                v-slot="{ errors }"
                                name="Tax line name"
                              >
                                <b-input
                                  id="start-date"
                                  type="text"
                                  v-model="taxLine.taxLineName"
                                ></b-input>
                                <span class="validate-error">{{
                                  errors[0]
                                }}</span>
                              </ValidationProvider>
                            </div>
                          </b-col>
                          <b-col cols="12" sm="6" md="4" class="tax-rate-col">
                            <div class="form-group">
                              <label for="start-date">Tax Rate</label>
                              <ValidationProvider
                                rules="required"
                                v-slot="{ errors }"
                                name="Tax rate"
                              >
                                <b-input
                                  id="start-date"
                                  type="text"
                                  v-model="taxLine.taxRates[0].tax"
                                ></b-input>
                                <span class="validate-error">{{
                                  errors[0]
                                }}</span>
                              </ValidationProvider>
                            </div>
                          </b-col>
                          <b-col cols="12" sm="12" md="4" class="mb-3 tax-line-type-col">
                            <div class="form-group">
                              <label for="start-date">Tax Line Type</label>
                              <eb-select
                                type="select"
                                :selected="taxLine.taxRates[0].rateType"
                                :options="['P']"
                                v-model="taxLine.taxRates[0].rateType"
                                label="text"
                                id="start-date"
                              ></eb-select>
                            </div>
                          </b-col>
                        </b-row>
                      </b-col>
                      <b-col cols="12" sm="12" md="3" class="btns-div">
                        <b-button
                          class="ml-2 ml-md-0"
                          variant="danger"
                          size="sm"
                          @click="removeTaxLime(idx, lIdx)"
                          v-if="data.taxLines.length > 1"
                        >
                          Remove
                          <i class="fa fa-minus-circle"></i>
                        </b-button>
                        <b-button
                          variant="primary"
                          size="sm"
                          @click="addTaxLines(idx)"
                          v-if="data.taxLines.length - 1 === lIdx"
                        >
                          Add Item
                          <i class="fa fa-plus-circle"></i>
                        </b-button>
                      </b-col>
                    </b-row>
                  </b-col>
                </div>
                <b-row class="p-2">
                  <b-col cols="12" md="12">
                    <div class="text-center">
                      <eb-button
                        class="btn"
                        classic="mr-1 btn-primary"
                        text="Update"
                        @click.prevent="handleSubmit"
                      ></eb-button>
                    </div>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </ValidationObserver>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import cInput from "@/components/Common/CustomInput";
import ebButton from "@/components/FormElements/Button";
import TaxCodeDetails from "@/components/MasterSetup/TaxCode/TaxCodeDetails.vue";
import moment from "moment";
import ebSelect from "@/components/FormElements/Select.vue";
import ComponentHeader from "@/components/componentNewHeader";
import {
  ValidationObserver,
  ValidationProvider,
  Validator,
} from "vee-validate";
import { createTaxLine } from "@/components/MasterSetup/TaxCode/taxCodeFactories";

export default {
  name: "editfaq",
  components: {
    ebButton,
    cInput,
    TaxCodeDetails,
    ebSelect,
    ComponentHeader,
    ValidationObserver,
    ValidationProvider,
  },
  data: () => {
    return {
      show: true,
      taxCode: "",
      country: "",
      startDate: 0,
      endDate: 0,
      taxLines: [createTaxLine()],
      details: {},
    };
  },
  // props: {
  //   details: {
  //     type: Object,
  //     required: true,
  //   },
  // },
  computed: {
    userRole() {
      if (this.$store.getters["auth/getUserRole"]) {
        return this.$store.getters["auth/getUserRole"];
      } else {
        return JSON.parse(sessionStorage.getItem("userLogin"))["role"];
      }
    },
  },
  methods: {
    addTaxLines(index) {
      this.details.restData.details[index].taxLines.push(createTaxLine());
    },
    removeTaxLime(detailIndex, lineIndex) {
      this.details.restData.details[detailIndex].taxLines.splice(lineIndex, 1);
    },
    async handleSubmit() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) return;

      let payload = {
        _id: this.details.restData._id,
        country: this.details.country,
        startDate: moment(this.details.startDate).toDate().getTime(),
        endDate: moment(this.details.endDate).toDate().getTime(),
        taxCode: this.details.taxCode,
        details: this.details.restData.details,
      };

      await this.$store.dispatch("taxcode/updateTaxcode", payload).then(() => {
        this.$swal({
          title: "Success",
          text: "Taxcode updated successfully!!",
          type: "success",
        });
      });
      this.$router.push({ name: "Taxcode" });
    },
  },
  async mounted() {
    this.details = { ...this.$route.params.data };
    this.details.startDate = moment(
      this.details.startDate,
      "DD/MM/yyyy"
    ).format("yyyy-MM-DD");
    this.details.endDate = moment(this.details.endDate, "DD/MM/yyyy").format(
      "yyyy-MM-DD"
    );
    await Validator.extend(
      "afterDate",
      (value, [otherValue]) => {
        return moment(value).diff(this.details.startDate, "hour") >= 0;
      },
      {
        hasTarget: true,
      }
    );
    await Validator.extend(
      "futureDisable",
      (value, [otherValue]) => {
        return moment().diff(this.details.startDate, "hour") >= 0;
      },
      {
        hasTarget: true,
      }
    );
  },
};
</script>
<style scoped>
.fa-plus {
  border-top-right-radius: 10px;
  border-top-left-radius: 17px;
  border-bottom-left-radius: 17px;
  background-color: #f0f3f5;
}
.btns-div {
  display: flex;
  align-items: center;
  gap: 10px;
  justify-content: flex-end;
}

@media (max-width: 767.98px) {
  .btns-div {
    justify-content: center !important;
  }
  
  .tax-fields-col {
    padding-left: 0 !important;
    margin-left: 0 !important;
  }
  
  .tax-line-name-col,
  .tax-rate-col,
  .tax-line-type-col {
    padding-left: 0 !important;
    margin-left: 1rem !important;
  }
}

@media (max-width: 575.98px) {
  .btns-div {
    justify-content: center !important;
  }
  
  .tax-fields-col {
    padding-left: 0 !important;
    margin-left: 1rem !important;
  }
  
  .tax-line-name-col,
  .tax-rate-col,
  .tax-line-type-col {
    padding-left: 0 !important;
    margin-left: 0 !important;
  }
}
</style>
